const colorSet: string[] = [
  '#4285F4', // Blue
  '#FBBC05', // Yellow
  '#EA4335', // Red
  '#F8878A', // Pink
  '#34A853', // Green
  '#662E9B', // Purple
  '#0F9D58', // Teal
  '#FF7043', // Orange
  '#A4BDFC', // Light Blue
  '#7FBA00', // Lime
  '#3367D6', // Dark Blue
  '#1EBEA5', // Turquoise
  '#FF4081', // Dark Pink
  '#AB47BC', // Dark Purple
  '#F09238', // Dark Orange
  '#E67141', // Burnt Orange
  '#00ACC1', // Steel Blue
  '#9E9E9E', // Grey
  '#FFD600', // Amber
  '#5C6BC0', // Indigo
];

export const getColor = (text: string): string => {
  const sum = text.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  const index = sum % colorSet.length;
  return colorSet[index] as unknown as string;
};
